// This is a auth page and responsible for the authentication redirect
import React from "react";
import AuthIndex from "../component/auth/AuthIndex";

export default function Auth() {
  return <AuthIndex />;
}
